import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const QuizCard = ({ quiz }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Nome:
                </div>
                <div className={styles.info}>
                    {quiz.titulo}
                </div>
                <div className={styles.title}>
                    Período
                </div>
                <div className={styles.info}>
                    { quiz.periodoAtividade === 0 ? "Indeterminado" : `${new moment(quiz.dataInicial).format('DD/MM/YYYY')} à ${new moment(quiz.dataFim).format('DD/MM/YYYY')}` }
                </div>
                <div className={styles.info}>
                    {quiz.ordem}
                </div>
            </div>

            <div className={styles.actionWrapper}>

                { !quiz.ativo && (<div className={styles.encerrado}>INATIVO</div>) }
                { quiz.ativo && (<div className={styles.andamento}>ATIVO</div>) }
                
                <button className={styles.editar} onClick={() => {history.push(`/quiz/resultados?QuizId=${quiz.quizId}`)}}>
                    Visualizar
                    <FontAwesomeIcon icon={faEye} className={styles.icon}/>
                </button>

                <button className={styles.editar} onClick={() => {history.push(`/quiz/detalhe?QuizId=${quiz.quizId}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faEdit} className={styles.icon}/>
                </button>
            </div>

        </div>
    )
}

export default QuizCard;